import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ExceptionQueryPopupComponent } from './exception-query-popup/exception-query-popup.component';

@Component({
    selector: 'app-exception-query',
    templateUrl: './exception-query.component.html',
    styleUrls: ['./exception-query.component.scss'],
    standalone: false
})
export class ExceptionQueryComponent implements OnInit {

    navLinks = [
    {
      label: 'Objects',
      link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
      index: 0
    },
    {
      label: 'Stage Objects',
      link: 'stageobject',
      index: 1
    },
    {
      label: 'Objects Mapping',
      link: 'mappingconfiguration',
      index: 1
    },
    {
      label: 'Attributes Mapping',
      link: 'attributemappingconfig',
      index: 1
    },
    {
      label: 'Value Mapping',
      link: 'fieldMapping',
      index: 1
    },
     {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
   
  ];
  paginationPageSize
  paginationNumberFormatter
  backgroundColor
  pagesize
  gridApi
  lastpage: any;
  currentpage: any;
  nextpage: any;
  totalpages: any;
  nextpageplusone: any;
   getdata
   buttonColor
   backgroundColorScreen
   components
   rowClassRules
   defaultColDef
   columnDefs
    buttonIdList = []
    
     getRowStyle: (params: any) => { backgroundColor: string; };
  
  any;
  dnsId: string;
  tableName: string;
  bootstrapColumn: number;
  buttonName: any;
  gridColumnAPI: any;

  constructor(private snackbar:MatSnackBar,private localStorrageSettings:LocalStorageSettingsService,private spinner:NgxUiLoaderService,
      private dialog: MatDialog,private commonService: CommonService,private userRoutingModule: UserRoutingModule,
       private reportLinkService:ReportlinksserviceService){
           this.components ={
         buttonRenderer: Actionbutton,
       }
  }

  ngOnInit(): void {
 this.tableName= 'exceptionqueries'
   this.dnsId = this.localStorrageSettings.getSettings("dnsName")
         let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorrageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

      this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
this.paginationPageSize = 10;
    this.columnDefs = [
  {
    headerName: 'Action',
    filter: false,
    cellRenderer: 'buttonRenderer',
    pinned: 'left',
    lockPinned: true,
    cellRendererParams: {
      values: this.buttonIdList,
      edit: this.editIcon.bind(this),
      delete: this.deleteIcon.bind(this),
    },
    width: 150
  },

  { 
    headerName: 'Order Id',
    headerTooltip: 'Order Id',
    tooltipValueGetter: params => 'Order Id : ' + params.value,
    field: 'orderId',
    filter: 'agTextColumnFilter',
    width: 100
  },

  { 
    headerName: 'Exception Type',
    headerTooltip: 'Exception Type',
    tooltipValueGetter: params => 'Exception Type : ' + params.value,
    field: 'exceptionType',
    filter: 'agTextColumnFilter',
    width: 150
  },

  { 
    headerName: 'Execution Type',
    headerTooltip: 'Execution Type',
    tooltipValueGetter: params => 'Execution Type : ' + params.value,
    field: 'executionType',
    filter: 'agTextColumnFilter',
    width: 150
  },

  { 
    headerName: 'Reference Source Object',
    headerTooltip: 'Reference Source Object',
    tooltipValueGetter: params => 'Reference Source Object : ' + params.value,
    field: 'referenceSourceObject',
    filter: 'agTextColumnFilter',
    width: 220
  },

  { 
    headerName: 'Reference Transform',
    headerTooltip: 'Reference Transform',
    tooltipValueGetter: params => 'Reference Transform : ' + params.value,
    field: 'referenceTransform',
    filter: 'agTextColumnFilter',
    width: 200
  },

  { 
    headerName: 'Reference Value Mapping',
    headerTooltip: 'Reference Value Mapping',
    tooltipValueGetter: params => 'Reference Value Mapping : ' + params.value,
    field: 'referenceValueMapping',
    filter: 'agTextColumnFilter',
    width: 220
  },

  { 
    headerName: 'Reference Library Objects',
    headerTooltip: 'Reference Library Objects',
    tooltipValueGetter: params => 'Reference Library Objects : ' + params.value,
    field: 'referenceLibraryObjects',
    filter: 'agTextColumnFilter',
    width: 220
  },

  { 
    headerName: 'Reference Global Objects',
    headerTooltip: 'Reference Global Objects',
    tooltipValueGetter: params => 'Reference Global Objects : ' + params.value,
    field: 'referenceGlobalObjects',
    filter: 'agTextColumnFilter',
    width: 220
  },

  { 
    headerName: 'Reference Global Source Objects',
    headerTooltip: 'Reference Global Source Objects',
    tooltipValueGetter: params => 'Reference Global Source Objects : ' + params.value,
    field: 'referenceGlobalSourceObjects',
    filter: 'agTextColumnFilter',
    width: 240
  },

  { 
    headerName: 'Global External Objects',
    headerTooltip: 'Global External Objects',
    tooltipValueGetter: params => 'Global External Objects : ' + params.value,
    field: 'globalExternalObjects',
    filter: 'agTextColumnFilter',
    width: 220
  },

  { 
    headerName: 'Exception Query',
    headerTooltip: 'Exception Query',
    tooltipValueGetter: params => 'Exception Query : ' + params.value,
    field: 'exceptionQuery',
    filter: 'agTextColumnFilter',
    width: 200
  },
   { 
    headerName: 'Tenant Id',
    headerTooltip: 'Tenant Id',
    tooltipValueGetter: params => 'tenantId : ' + params.value,
    field: 'tenantId',
    filter: 'agTextColumnFilter',
    width: 150
  },
    { 
    headerName: 'Status',
    headerTooltip: 'Status',
    tooltipValueGetter: params => 'Status : ' + params.value,
    field: 'status',
    filter: 'agTextColumnFilter',
    width: 100,
    cellStyle: function (params){
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        } 
  },

];

        this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' };
      }
    };

    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")
  }



  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }

  onGridReady(params){
    // this.gridApi = params.api;
    this.gridApi = params;
      this.gridColumnAPI = params.columnApi;
     params.api.setGridOption('rowData', [])
    this.spinner.start()
    var tenantId = localStorage.getItem('dnsName');
    
     console.log(tenantId)
     this.retrieve(tenantId)
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  retrieve(tenantId: any){
    console.log("inside retrival")
    this.commonService.retrieveExceptionByTenantId(tenantId).subscribe(response=>{
      console.log(response)
     if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', [])
      }else{
        console.log(response)
        // this.getdata = response
        // console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', response)
        this.spinner.stop();
      }
    })
  }

openSaveForm(buttonName) {
  this.buttonName = buttonName;
  
  let dialogRef = this.dialog.open(ExceptionQueryPopupComponent, {
    panelClass: 'custom-dialog-container-materialFulfilment',
    width: '80%',
    autoFocus: false,
    data: { editData: null },
    disableClose: true,
  });

  dialogRef.afterClosed().subscribe(result => {
    // Only refresh if save was successful (result is truthy)
    if (result) {
      // Call retrieve() directly, NOT onGridReady()
      const tenantId = localStorage.getItem('dnsName');
      this.retrieve(tenantId);
    }
  });
}


 editIcon(e) {
  let rowData = e.rowData;
  console.log("Edit clicked:", rowData);

  if (rowData.status === "No") {
    this.snackbar.open("Selected record is already deleted", "OK", { duration: 5000 });
    return;
  }

  let dialogRef = this.dialog.open(ExceptionQueryPopupComponent, {
    panelClass: 'custom-dialog-container-materialFulfilment',
    width: '80%',
    autoFocus: false,
    disableClose: true,
    data: { editData: rowData },   // send existing data to popup
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      const tenantId = localStorage.getItem('dnsName');
      this.retrieve(tenantId);   // refresh grid
    }
  });
}


  deleteIcon(event) {
  console.log("Delete clicked:", event);

  if (event.rowData.status === "No") {
    this.snackbar.open("Selected record is already deleted", "OK", { duration: 5000 });
    return;
  }

  if (confirm("Are you sure you want to delete this record?")) {
    this.spinner.start();

    this.commonService.deleteExceptionQueryById(event.rowData.exceptionQueryId)
      .subscribe(result => {
        console.log(result);

        if (String(result.data) === "Successfully record is deleted") {
          this.snackbar.open("Successfully record is deleted", "OK", { duration: 5000 });
        } else {
          this.snackbar.open("Cannot delete selected record", "OK", { duration: 5000 });
        }

        const tenantId = localStorage.getItem('dnsName');
        this.retrieve(tenantId);  // refresh grid
        this.spinner.stop();
      });
  }
}

    getRouterLink(event): any[] {
      if (event.label === 'Objects') {
        return ['/user/Menubar/trnxBaseComponent'];
      } else {
        return [`/user/Menubar/${event.link}`];
      }
    }

getQueryParams(label: string): any {
  if (label === 'Objects') {
    return {
      screenType: 'Dynamic/Transactions',
      tableName: 'objectmetadata',
      headerNameHtml: 'Objects'
    };
  }
  return null;
}
  

}